(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfb--header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfb--ingredients-tabs"] && !Shopify.designMode) return;
  try {
    
  // accordion to tabs functionality
  let tabOrder = 0;
  const tabs = document.querySelectorAll('.tabby-accordion [role="tab"]');
  const tabContents = document.querySelectorAll('.tabby-accordion [role="tabpanel"]');

  // loop through each tab
  tabs.forEach((tab) => {
    // get tab parent
    const parent = tab.parentNode;

    // get index (order number)	of each tab
    const index = Array.prototype.indexOf.call(parent.children, tab);

    if (index === 0) {
      tabOrder = index;
    } else {
      tabOrder = index * 2;
    }

    tab.style.order = tabOrder;
  });

  // loop through each tab content
  tabContents.forEach((tabContent) => {
    // get tab parent
    const parent = tabContent.parentNode;

    // get index (order number)	of each tab
    const index = Array.prototype.indexOf.call(parent.children, tabContent);

    if (index === 0) {
      tabOrder = index + 1;
    } else {
      tabOrder = index * 2 + 1;
    }

    tabContent.style.order = tabOrder;
  });

  // tabs functionality
  function initTabs(container) {
    const tablist = container.querySelector("[role='tablist']");
    const tabs = Array.from(tablist.querySelectorAll("[role='tab']"));

    const firstTab = tabs[0];
    const lastTab = tabs[tabs.length - 1];

    const tabBackgroundImageUrl = firstTab.dataset.backgroundImage;
    // const imageUrl = element.getAttribute('data-image-url');
    let tabBackgroundContainer = document.getElementsByClassName('ingredients-section');
    if (tabBackgroundImageUrl) {
      tabBackgroundContainer[0].style.backgroundImage = `url("${tabBackgroundImageUrl}")`;
    }

    function activateTab(tab) {
      const tabpanelID = tab.getAttribute('aria-controls');
      const tabpanel = document.getElementById(tabpanelID);

      tab.setAttribute('aria-selected', true);
      tab.removeAttribute('tabindex');
      tabpanel.setAttribute('tabindex', 0);

      const tabBackgroundImageUrl = tab.dataset.backgroundImage;
      // const imageUrl = element.getAttribute('data-image-url');
      let tabBackgroundContainer = document.getElementsByClassName('ingredients-section');
      if (tabBackgroundImageUrl) {
        tabBackgroundContainer[0].style.backgroundImage = `url("${tabBackgroundImageUrl}")`;
      }

      // deactivate other tabs and tabpanels
      document.querySelectorAll('[role="tab"], [role="tabpanel"]').forEach((el) => {
        if (el !== tab && el !== tabpanel) {
          if (el.matches('[role="tab"]')) {
            // el is a tab
            el.setAttribute('aria-selected', false);
            el.setAttribute('tabindex', -1);
          } else {
            // el is a tabpanel
            el.removeAttribute('tabindex');
          }
        }
      });
    }

    function handleClick(e) {
      const { target } = e;
      if (target.matches('[role="tab"]'))
        // matches() takes css selectors as args
        activateTab(target);
    }

    function handlePreviousTab(currentTab) {
      let activeTab;
      if (currentTab === firstTab) {
        activeTab = lastTab;
      } else {
        index = tabs.indexOf(currentTab);
        activeTab = tabs[index - 1];
      }

      activateTab(activeTab);
      activeTab.focus();
    }

    function handleNextTab(currentTab) {
      let activeTab;
      if (currentTab === lastTab) {
        activeTab = firstTab;
      } else {
        index = tabs.indexOf(currentTab);
        activeTab = tabs[index + 1];
      }

      activateTab(activeTab);
      activeTab.focus();
    }

    function handleKeyboardNavigation(e) {
      const { target } = e;
      if (target.matches('[role="tab"]')) {
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            handlePreviousTab(target);
            break;

          case 'ArrowRight':
          case 'ArrowDown':
            handleNextTab(target);
            break;

          // fn + Left Arrow on Mac
          case 'Home':
            activateTab(firstTab);
            firstTab.focus();
            break;

          // fn + Right Arrow on Mac
          case 'End':
            activateTab(lastTab);
            lastTab.focus();
            break;
        }
      }
    }

    tablist.addEventListener('click', handleClick);
    tablist.addEventListener('keydown', handleKeyboardNavigation);
  }

  const tabContainers = document.querySelectorAll('.tabs');
  tabContainers.forEach((container) => initTabs(container));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfb--product-reviews"] && !Shopify.designMode) return;
  try {
    
  const paginationNumbers = document.getElementById("pagination-numbers");
const paginatedList = document.getElementById("paginated-list");
const listItems = paginatedList.querySelectorAll("div.jdgm-rev");
const nextButton = document.getElementById("next-button");
const prevButton = document.getElementById("prev-button");

const paginationLimit = 10;
const pageCount = Math.ceil(listItems.length / paginationLimit);
let currentPage = 1;

const disableButton = (button) => {
  button.classList.add("disabled");
  button.setAttribute("disabled", true);
};

const enableButton = (button) => {
  button.classList.remove("disabled");
  button.removeAttribute("disabled");
};

const handlePageButtonsStatus = () => {
  if (currentPage === 1) {
    disableButton(prevButton);
  } else {
    enableButton(prevButton);
  }

  if (pageCount === currentPage) {
    disableButton(nextButton);
  } else {
    enableButton(nextButton);
  }
};

const handleActivePageNumber = () => {
  document.querySelectorAll(".pagination-number").forEach((button) => {
    button.classList.remove("active");
    const pageIndex = Number(button.getAttribute("page-index"));
    if (pageIndex == currentPage) {
      button.classList.add("active");
    }
  });
};

const appendPageNumber = (index) => {
  const pageNumber = document.createElement("button");
  pageNumber.className = "pagination-number";
  pageNumber.innerHTML = index;
  pageNumber.setAttribute("page-index", index);
  pageNumber.setAttribute("aria-label", "Page " + index);

  paginationNumbers.appendChild(pageNumber);
};

const getPaginationNumbers = () => {
  for (let i = 1; i <= pageCount; i++) {
    appendPageNumber(i);
  }
};

const setCurrentPage = (pageNum) => {
  currentPage = pageNum;

  handleActivePageNumber();
  handlePageButtonsStatus();
  
  const prevRange = (pageNum - 1) * paginationLimit;
  const currRange = pageNum * paginationLimit;

  listItems.forEach((item, index) => {
    item.classList.add("hidden");
    if (index >= prevRange && index < currRange) {
      item.classList.remove("hidden");
    }
  });
};

window.addEventListener("load", () => {
  getPaginationNumbers();
  setCurrentPage(1);

  prevButton.addEventListener("click", () => {
    setCurrentPage(currentPage - 1);
  });

  nextButton.addEventListener("click", () => {
    setCurrentPage(currentPage + 1);
  });

  document.querySelectorAll(".pagination-number").forEach((button) => {
    const pageIndex = Number(button.getAttribute("page-index"));

    if (pageIndex) {
      button.addEventListener("click", () => {
        setCurrentPage(pageIndex);
      });
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfb--shade-finder-old"] && !Shopify.designMode) return;
  try {
    
  let getSiblings = function (e) {
    // for collecting siblings
    let siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
      return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;
    // collecting siblings
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  };

  const shadeFinder = document.getElementsByClassName('shade-finder')[0];
  const shadeFinderColumns = shadeFinder.getElementsByClassName('multicolumn-list__item');
  for (let i = 0; i < shadeFinderColumns.length; i++) {
    var shadeFinderColumn = shadeFinderColumns[i];
    //console.log(shadeFinderColumn);
    var sliderId = 'shade-range-slider-' + i;
    var slider = document.getElementById(sliderId);

    //var sliderThumb = document.querySelector("input[type=range]");
    //var images = shadeFinderColumn.getElementsByClassName("multicolumn-card__image");
    var images = shadeFinderColumn.getElementsByClassName('slide_link');

    var sliderNumString = slider.value;

    var sliderNum = parseInt(sliderNumString);

    images[sliderNum].style.opacity = 1;
    images[sliderNum].style.visibility = 'visible';

    slider.oninput = function () {
      // console.log(images);
      sliderNumString = this.value;
      var sliderNum = parseInt(sliderNumString);
      let imagesNew = getSiblings(this.parentNode);
      //console.log(imagesNew);
      for (let i = 0; i < imagesNew.length; i++) {
        if (i == sliderNum) {
          //sliderThumb.style.setProperty('--thumb-color', images[i].dataset.color);
          imagesNew[i].style.opacity = 1;
          imagesNew[i].style.visibility = 'visible';
        } else {
          imagesNew[i].style.opacity = 0;
          imagesNew[i].style.visibility = 'hidden';
        }
      }
    };
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfb--shade-finder"] && !Shopify.designMode) return;
  try {
    
  let getSiblings = function (e) {
    // for collecting siblings
    let siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
      return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;
    // collecting siblings
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  };

  /**
   * Gets all sibling elements of a given element's parent that match a specific class name.
   * @param {Element} element The starting element.
   * @param {string} className The class name to filter siblings by (without the dot).
   * @returns {Array<Element>} An array of matching sibling elements.
   */
  function getParentSiblingsWithClass(element, className) {
    const parent = element.parentElement; // Get the parent element.

    if (!parent) {
      return []; // Return an empty array if no parent exists.
    }

    // Get all children of the parent (which are siblings to the original element's parent).
    const allSiblingsOfParent = [...parent.parentElement.children];

    // Filter the siblings to find those that have the target class name.
    const matchingSiblings = allSiblingsOfParent.filter((sibling) => {
      // Exclude the original parent element itself
      if (sibling === parent) {
        return false;
      }
      // Check if the sibling has the specified class
      return sibling.classList.contains(className);
    });

    return matchingSiblings;
  }

  const shadeFinder = document.getElementsByClassName('shade-finder')[0];
  const shadeFinderColumns = shadeFinder.getElementsByClassName('multicolumn-list__item');
  for (let i = 0; i < shadeFinderColumns.length; i++) {
    var shadeFinderColumn = shadeFinderColumns[i];
    //console.log(shadeFinderColumn);
    var sliderId = 'shade-range-slider-' + i;
    var slider = document.getElementById(sliderId);

    //var sliderThumb = document.querySelector("input[type=range]");
    var images = shadeFinderColumn.getElementsByClassName('multicolumn-card__image-wrapper');

    //var images = shadeFinderColumn.getElementsByClassName('slide_link');

    var sliderNumString = slider.value;

    var sliderNum = parseInt(sliderNumString);

    //images[sliderNum].style.opacity = 1;
    //images[sliderNum].style.visibility = 'visible';
    images[sliderNum].style.display = 'block';

    slider.oninput = function () {


         var slider_buttons_parent = getParentSiblingsWithClass(this, 'slider-buttons');
        if (slider_buttons_parent.length > 0) {
          const slider_buttons = slider_buttons_parent[0].getElementsByClassName('siblings__swatch');
          const slider_buttons_array = Array.from(slider_buttons);
           slider_buttons_array.forEach((s_btn, index) => {
             s_btn.querySelector('.siblings__button').classList.remove(activeClass);
            if(this.value == index) {
                 s_btn.querySelector('.siblings__button').classList.add(activeClass);

            }
            
            });
        }

    
      // console.log(images);
      sliderNumString = this.value;
      var sliderNum = parseInt(sliderNumString);
      //let imagesNew = getSiblings(this.parentNode);
      //let imagesNew = this.parentElement.previousElementSibling.getElementsByClassName('slide_link');
      let imagesNew = getParentSiblingsWithClass(this, 'multicolumn-card__image-wrapper');

      //console.log(imagesNew);
      for (let i = 0; i < imagesNew.length; i++) {
        if (i == sliderNum) {
          //sliderThumb.style.setProperty('--thumb-color', images[i].dataset.color);
          //imagesNew[i].style.opacity = 1;
          //imagesNew[i].style.visibility = 'visible';
          imagesNew[i].style.display = 'block';
        } else {
          //imagesNew[i].style.opacity = 0;
          //imagesNew[i].style.visibility = 'hidden';
          imagesNew[i].style.display = 'none';
        }
      }
    };

   
    var slider_buttons = shadeFinderColumn.getElementsByClassName('siblings__swatch');
    const slider_buttons_array = Array.from(slider_buttons);
    const activeClass = 'active';

    slider_buttons_array.forEach((slider_button, index) => {
      
      slider_button.addEventListener('click', (event) => {

        slider_buttons_array.forEach((s_btn) => {
           
             s_btn.querySelector('.siblings__button').classList.remove(activeClass);
            });
         
        event.target.classList.add(activeClass);

        var sliderParent = getParentSiblingsWithClass(event.target.parentElement, 'shade-range-slider-parent');
        if (sliderParent.length > 0) {
          const slider = sliderParent[0].querySelector('.shade-range-slider');
          slider.value = index;
        }

        // The 'event.target' property refers to the specific button that was clicked
        //const buttonText = event.target.innerText;
        let imagesNew = getParentSiblingsWithClass(event.target.parentElement, 'multicolumn-card__image-wrapper');

        //console.log(event.target);
        for (let i = 0; i < imagesNew.length; i++) {
          if (i == index) {
            imagesNew[i].style.display = 'block';
          } else {
            imagesNew[i].style.display = 'none';
          }
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
